import axios from "axios";

export default class ChatServices {
  constructor() {
    this.api = null;
    this.#initAxios();
  }

  #initAxios() {
    let id_token = localStorage.getItem("id_token");

    this.api = axios.create({
      baseURL: process.env.VUE_APP_URL_AI,
      // baseURL: "https://ai-api.terminalads.com",

      timeout: 15000,
      headers: {
        Authorization: !!id_token ? "Bearer " + id_token : undefined,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*",
        "Content-Type": "application/json",
      },
    });
  }

  sendNewMessage(message, model, id) {
    const URL = `${process.env.VUE_APP_URL_AI}/chat/send/message`;
    console.log(id);

    return new Promise((resolve, reject) => {
      this.api
        // .post("/v1/chat-ai", {
        .post(URL, {
          message: message,
          model: model,
          chat_id: !!id ? id : null,
        })
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    });
  }

  getModels() {
    const URL = `${process.env.VUE_APP_URL_AI}/route/models?type=chat&route_id=`;
    return new Promise((resolve, reject) => {
      this.api
        .get(URL)
        .then((data) => resolve(data))
        .catch((error) => reject(err));
    });
  }

  getAllArchiveChats() {
    const URL = `${process.env.VUE_APP_URL_AI}/chat`;

    return new Promise((resolve, reject) => {
      this.api
        .get(URL)
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  }

  getArchiveChat(id) {
    const URL = `${process.env.VUE_APP_URL_AI}/chat/messages/${id}`;

    return new Promise((resolve, reject) => {
      this.api
        .get(URL)
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  }
}
